import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import AlertStack from '../components/AlertStack';

const AlertContext = createContext(null);

export const AlertProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);

  const push = useCallback(({ type = 'info', title = '', message = '', duration = 3200 }) => {
    const id = crypto.randomUUID();
    const alert = { id, type, title, message };
    setAlerts((prev) => [...prev, alert]);
    if (duration !== null) {
      setTimeout(() => {
        setAlerts((prev) => prev.filter((a) => a.id !== id));
      }, duration);
    }
  }, []);

  const remove = useCallback((id) => {
    setAlerts((prev) => prev.filter((a) => a.id !== id));
  }, []);

  const value = useMemo(() => ({ push, remove }), [push, remove]);

  return (
    <AlertContext.Provider value={value}>
      {children}
      <AlertStack alerts={alerts} onClose={remove} />
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const ctx = useContext(AlertContext);
  if (!ctx) throw new Error('useAlert must be used within AlertProvider');
  return ctx;
};


